module.exports = __webpack_public_path__ + "static/media/AssessmentIcon.54767242.svg";